<app-programmes [sbEvent]="event"></app-programmes>